const mapsArray = document.querySelectorAll(".google-map");
const initMapScript = () => {
    const APIKEY = "AIzaSyAaEIa_ColswUoGF6gluW7Qgy95TtmBMM8";
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${APIKEY}&callback=initMap&libraries=&v=weekly`;
    document.head.appendChild(script);
};
const initMap = () => {
    mapsArray && mapsArray.length > 0 && mapsArray.forEach((singleMap) => {
        //styling map 
        const styleMap = [
            {
                "featureType": "landscape",
                "stylers": [
                    {
                        "hue": "#FFBB00"
                    },
                    {
                        "saturation": 43.400000000000006
                    },
                    {
                        "lightness": 37.599999999999994
                    },
                    {
                        "gamma": 1
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "stylers": [
                    {
                        "hue": "#FFC200"
                    },
                    {
                        "saturation": -61.8
                    },
                    {
                        "lightness": 45.599999999999994
                    },
                    {
                        "gamma": 1
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "stylers": [
                    {
                        "hue": "#FF0300"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 51.19999999999999
                    },
                    {
                        "gamma": 1
                    }
                ]
            },
            {
                "featureType": "road.local",
                "stylers": [
                    {
                        "hue": "#FF0300"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 52
                    },
                    {
                        "gamma": 1
                    }
                ]
            },
            {
                "featureType": "water",
                "stylers": [
                    {
                        "hue": "#0078FF"
                    },
                    {
                        "saturation": -13.200000000000003
                    },
                    {
                        "lightness": 2.4000000000000057
                    },
                    {
                        "gamma": 1
                    }
                ]
            },
            {
                "featureType": "poi",
                "stylers": [
                    {
                        "hue": "#00FF6A"
                    },
                    {
                        "saturation": -1.0989010989011234
                    },
                    {
                        "lightness": 11.200000000000017
                    },
                    {
                        "gamma": 1
                    }
                ]
            }
        ];
        // lat lng marker
        const markerLatArray = singleMap.getAttribute("data-marker-lat").split(";");
        const markerLngArray = singleMap.getAttribute("data-marker-lng").split(";");
        // create empty LatLngBounds object to center map automatically between markers
        const bounds = new google.maps.LatLngBounds();
        if (markerLatArray && markerLngArray) {
            const map = new google.maps.Map(singleMap, {
                zoom: 50,
                disableDefaultUI: true,
                styles: styleMap
            });
            if (markerLatArray && markerLngArray && markerLatArray.length > 0 && markerLngArray.length > 0) {
                for (let i = 0; i < markerLatArray.length && i < markerLngArray.length; i++) {
                    const markerLat = parseFloat(markerLatArray[i]);
                    const markerLng = parseFloat(markerLngArray[i]);
                    const marker = new google.maps.Marker({
                        position: { lat: markerLat, lng: markerLng },
                        map: map
                    });
                    bounds.extend(marker.getPosition());
                }
                map.fitBounds(bounds);
            }
        }
    });
};
